import React from "react";
import { getClassName } from "@utils";
import { CheckedIcon } from "@taskpane/icons";
import { Button, ButtonSize, ButtonVariant } from "@taskpane/components";
import css from "./WizardAnswer.module.scss";

export interface WizardAnswerOption {
  label: string;
  isSelected: boolean;
}

export interface WizardAnswerProps {
  options: WizardAnswerOption[];
}

const WizardAnswer: React.FC<WizardAnswerProps> = ({ options }) => {
  const attrs = {
    container: {
      className: css.container,
    },
  };

  const renderOptions = () =>
    options.map(({ label, isSelected }, index) => {
      const attrs = {
        button: {
          disabled: true,
          className: getClassName(css.button, isSelected ? css.buttonPrimary : css.buttonSecondary),
          size: ButtonSize.XS,
          variant: isSelected ? ButtonVariant.Primary : ButtonVariant.Secondary,
        },
      };

      return (
        <Button {...attrs.button} key={index}>
          <span>{label}</span>
          {isSelected ? <CheckedIcon /> : null}
        </Button>
      );
    });

  return <div {...attrs.container}>{renderOptions()}</div>;
};

export default WizardAnswer;
